// NOTICE: KAPTION-INTEGRATION
// Kaption Debug Routes
import { frontendURL } from '../../../helper/URLHelper';

const KaptionDebugIndex = () => import('./KaptionDebug.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kaption-debug'),
    name: 'kaption_debug_index',
    meta: {
      permissions: ['administrator'],
    },
    component: KaptionDebugIndex,
  },
];
